import { createActions, createReducer } from 'reduxsauce'

import ConsultaOrdensPagamentosExtraorcamentariasService from '../../servicos/ConsultaOrdensPagamentosExtraorcamentariasService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaOrdensPagamentosExtraorcamentariasInicio: [],
    buscaConsultaOrdensPagamentosExtraorcamentariasErro: ['erro'],
    buscaConsultaOrdensPagamentosExtraorcamentariasSucesso: ['consultaOrdensPagamentosExtraorcamentarias'],
    limpar: [],
    setConsultaOrdensPagamentosExtraorcamentariasEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaOrdensPagamentosExtraorcamentarias = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaOrdensPagamentosExtraorcamentariasInicio())
        let serv = new ConsultaOrdensPagamentosExtraorcamentariasService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaOrdensPagamentosExtraorcamentariasSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaOrdensPagamentosExtraorcamentariasErro(error)))
    }
}

const buscaConsultaOrdensPagamentosExtraorcamentariasInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaOrdensPagamentosExtraorcamentariasErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaOrdensPagamentosExtraorcamentariasSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaOrdensPagamentosExtraorcamentarias.resultado,
        dataSincronizacaoDados: action.consultaOrdensPagamentosExtraorcamentarias.dataSincronizacaoDados,
        fonte: action.consultaOrdensPagamentosExtraorcamentarias.fonte,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaOrdensPagamentosExtraorcamentariasEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS_INICIO]: buscaConsultaOrdensPagamentosExtraorcamentariasInicio,
    [Types.BUSCA_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS_ERRO]: buscaConsultaOrdensPagamentosExtraorcamentariasErro,
    [Types.BUSCA_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS_SUCESSO]: buscaConsultaOrdensPagamentosExtraorcamentariasSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS_ESTADO_DT]: setConsultaOrdensPagamentosExtraorcamentariasEstadoDT,
})
